<section class="grid md:grid-cols-5 gap-8 p-10 items-center font-thin  overflow-auto hide-scrollbar">
  <div class="text-xl order-1 col-span-3 flex flex-col gap-4 justify-center px-4 w-full">
    <div class="font-medium text-3xl">
      Welcome to Wundart
    </div>
    <div>
      Every great project begins with a little spark of wonder. For us, that spark came from the wunderkammer—the “cabinets of curiosity” that once gathered marvelous objects from around the world. We loved that sense of discovery and surprise, and we wanted to bring it into today’s art world. That’s how Wundart was born: a place where art can be found, shared, and collected with the same excitement as opening a cabinet full of treasures.
    </div>
    <div class="font-medium text-3xl">
      What is Wundart?
    </div>
    <div>
      Wundart is an online portal where artists can sell their works directly, and where collectors (both seasoned and new) can explore art with a fresh perspective. It’s not just a marketplace—it’s a community. Think of it as a bridge between the artists’s and the curiosity of those who want to discover them.
    </div>
  </div>
  <div class="flex flex-col justify-center order-2 max-w-none md:max-w-96 col-span-5 md:col-span-2">
    <img class=" shadow-lg w-full object-cover" src="image1.jpeg">
    <div class="text-xl whitespace-nowrap">Elia panori - Connessione</div>
  </div>
  <div class="flex flex-col order-5 md:order-3 justify-center max-w-none md:max-w-96  col-span-5 md:col-span-2 m-auto">
    <img class=" shadow-lg w-full object-cover" src="image2.jpeg">
    <div class="text-xl whitespace-nowrap">Elia panori - Energia immobile 2</div>
  </div>
  <div class="text-xl order-4 col-span-5 md:col-span-3 flex flex-col gap-4 justify-center px-4 w-full">
    <div class="font-medium text-3xl">
      Our Roots in Milan
    </div>
    <div>
      We’re proud to grow out of the Milanese art scene, where tradition and innovation meet every day. Wundart works hand in hand with two inspiring partners:
    </div>
    <ul class="list-disc list-inside">
      <li>
        Young Art Hunters – an association that shines a light on emerging artists through events and art fairs. Their energy and vision keep us connected to the future of art.
      </li>
      <li>
        Almach Art Gallery – a respected Milan-based gallery that brings experience, curatorial insight, and a sharp eye for quality.
      </li>
    </ul>
    <div>
      Together, we’re creating a space that celebrates both the new and the established, the playful and the profound.    </div>
  </div>
  <div class="text-xl order-5 col-span-3 flex flex-col gap-4 justify-center px-4 w-full">
    <div class="font-medium text-3xl">
      Why “Wundart”?
    </div>
    <div>
      Because art should always spark wonder (Wunder in German). Our name is a playful nod to that feeling. We want collectors and visitors to feel the thrill of discovering something unexpected, and artists to feel seen, supported, and celebrated.
    </div>
    <div>
      A Place to Discover, Collect, and Connect
    </div>
    <div>
      At Wundart you’ll find:
    </div>
    <ul>
      <li>
        Emerging voices who are shaping the art of tomorrow.



      </li>
      <li>
        Established talents who continue to surprise us.

      </li>
      <li>
        A community where creativity isn’t just displayed—it’s shared.

      </li>
    </ul>
    <div>
      This is just the beginning of our journey, and we’d love for you to be part of it. Explore, fall in love with an artwork, start a collection, or simply wander and let curiosity guide you.
    </div>
    <div>
      Welcome to Wundart. A home for wonder, art, and the people who love them.

    </div>
  </div>
  <div class="flex flex-col order-6 justify-center max-w-none md:max-w-96 col-span-5 md:col-span-2">
    <img class=" shadow-lg w-full object-cover" src="image3.jpeg">
    <div class="text-xl whitespace-nowrap">Elia panori - Energia immobile 1</div>

  </div>
</section>
